import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import React from "react";

/**
 * Interface para o modelo de Página.
 * Define a estrutura de dados esperada para um objeto de página.
 */
export interface IPageModel extends IGenericBaseModel {
  uuid?: string;
  dateCreated?: string;
  dateModified?: string;
  isActive?: boolean;
  name: string;
  path: string;
  params?: Record<string, string>;
}

/**
 * Classe que representa o modelo de Página.
 * Implementa a interface IPageModel e fornece métodos úteis.
 */
export class PageModel implements IPageModel {
  uuid?: string;
  key?: React.Key;
  dateCreated?: string;
  dateModified?: string;
  isActive?: boolean;
  name: string;
  path: string;
  params?: Record<string, string>;

  constructor(data: IPageModel) {
    this.uuid = data?.uuid;
    this.key = data?.uuid;
    this.dateCreated = data?.dateCreated;
    this.dateModified = data?.dateModified;
    this.isActive = data?.isActive ?? true;
    this.name = data?.name ?? '';
    this.path = data?.path ?? '';
    this.params = data?.params;
  }

  /**
   * Monta uma URL para navegação com base no caminho e parâmetros da página.
   * @param dict - Um dicionário contendo os valores para os parâmetros da URL.
   * @returns A string da URL formatada.
   * Exemplo de output: /allocate-container/type/uuidType/measure/uuidMeasure
   */
  mountPageToPushUrl(dict: Record<string, string> = {}): string {
    let pageToPush = `/${this.path}`;

    if (this.params) {
      Object.entries(this.params).forEach(([key, value]) => {
        const paramValue = dict[value];
        if (paramValue) {
          pageToPush = `${pageToPush}/${key}/${paramValue}`;
        }
      });
    }

    return pageToPush;
  }
}